import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { MyPage } from "./mypage/MyPage";
import { RoleCreate } from "./roles/create/RoleCreate";
import { RoleList } from "./roles/list/RoleList";
import { Items } from "./items/Items";
import { AccountList } from "./account/list/AccountList";
import { AccountCreate } from "./account/create/AccountCreate";
import Company from "./company/Company";

export default function Manage() {
    const { key } = useLocation();

    return (
        <Routes>
            <Route key={key} path={"mypage"} element={<MyPage />} />
            <Route key={key} path={"role/list"} element={<RoleList />} />
            <Route key={key} path={"role/detail/:id"} element={<RoleCreate />} />
            <Route key={key} path={"role/create"} element={<RoleCreate />} />
            <Route key={key} path={"items"} element={<Items />} />
            <Route key={key} path={"account/list"} element={<AccountList />} />
            <Route key={key} path={"account/detail/:id"} element={<AccountCreate />} />
            <Route key={key} path={"account/create"} element={<AccountCreate />} />
            <Route key={key} path={"company"} element={<Company />} />
            <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
        </Routes>
    );
}
